import { Box, Button } from "@mui/material";

export default function ChatModeSwitch({ value, onChange }) {
  const options = [
    { value: "rrhh", label: "Chat RRHH" },
    { value: "groups", label: "Grupos" },
  ];

  return (
    <Box
      sx={{
        mb: 1,
        p: 0.5,
        borderRadius: 999,
        bgcolor: "rgba(247,247,248,0.82)",
        display: "flex",
        gap: 0.5,
      }}
    >
      {options.map((option) => {
        const active = value === option.value;

        return (
          <Button
            key={option.value}
            onClick={() => onChange?.(option.value)}
            sx={{
              flex: 1,
              height: 30,
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 900,
              bgcolor: active ? "secondary.500" : "transparent",
              color: active ? "common.white" : "primary.900",
              "&:hover": {
                bgcolor: active ? "secondary.600" : "neutral.100",
              },
            }}
          >
            {option.label}
          </Button>
        );
      })}
    </Box>
  );
}